import styled from "styled-components";
import { propStyling } from "../../../shared";
export const RootContainer = styled.div.withConfig({
  displayName: "RootContainer"
})(["all:initial;display:inline-flex;flex-direction:column;min-width:max-content;", ""], propStyling);
//# sourceMappingURL=RootContainer.js.map